import React from 'react';
import Carousel from 'react-bootstrap/Carousel';





export default  function CarrouselBox (props) {
 
 	return (
        <div className='container-md'>
 		
        <Carousel>
        {props.img.map((img,index) => {
          return(
            <Carousel.Item key = {index}>
            <img
              className="d-block w-100"
              src={img}
              alt="slide"
            />
          </Carousel.Item>

            )
        })}
          
        </Carousel>
        </div>
 		);
 }  



